import React from "react"

import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import BlogHelpers from "../helpers/BlogHelpers"
import Spinner from "./_base/Spinner"

import { blogPathTranslator } from "../helpers/BlogPathTranslator"

import * as relatedContentStyles from "../styles/RelatedContent.module.css"

import moment from "moment"

function RelatedContent(props) {
  const [settingsLoaded, updateState] = React.useState()
  const forceUpdate = React.useCallback(() => updateState({}), [])

  const categories = React.useRef({})
  const tags = React.useRef({})
  const activeFilters = {
    cats: [],
    tags: [],
  }
  const blogUriRoot = React.useRef(
    blogPathTranslator(props.pageContext.language.slug),
  )

  const [loadingPosts, setLoadingPosts] = React.useState(true)
  const [posts, setPosts] = React.useState([])
  const { wordpressUrl } = props.pageContext

  const fetchPosts = React.useCallback(
    async (filters, token = null, pageNumber = undefined, pageArticles = 4) => {
      return BlogHelpers.fetchPosts(
        token,
        BlogHelpers.updateFilters(filters, {
          cats: [],
          tags: [],
        }),
        categories.current,
        tags.current,
        wordpressUrl,
        pageNumber,
        pageArticles,
      )
    },
    [wordpressUrl],
  )

  React.useEffect(() => {
    const loadTagsDictionary = async () => {
      categories.current =
        await BlogHelpers.getCategoriesDictionary(wordpressUrl)
      tags.current = await BlogHelpers.getTagsDictionary(wordpressUrl)

      forceUpdate()
    }

    loadTagsDictionary()
  }, [wordpressUrl, forceUpdate])

  React.useEffect(() => {
    const loadBaseSettings = async () => {
      setLoadingPosts(true)
      const filters = {
        cats:
          props.postCategories.map(f => f.toLowerCase().replace(` `, `-`)) ||
          [],
        tags: [],
      }
      const fecthed = await fetchPosts(filters)
      if (fecthed.data) {
        const posts = fecthed.data
          .filter(p => p.slug !== props.postId)
          .slice(0, 3)
        setPosts(posts, setLoadingPosts(false))
      } else {
        setPosts(fecthed.data, setLoadingPosts(false))
      }
    }

    if (tags.current && Object.keys(tags.current).length) loadBaseSettings()
  }, [props.postCategories, props.postId, fetchPosts, settingsLoaded])

  return (
    <div className={`${props.className} ${relatedContentStyles.wrapper}`}>
      <div className={`row ${relatedContentStyles.heading}`}>
        <div className={`col-12 ${relatedContentStyles.titleWrapper}`}>
          <h1 className={`${relatedContentStyles.title}`}>Related content</h1>
        </div>
      </div>

      {loadingPosts && (
        <div className={`row ${relatedContentStyles.postList}`}>
          <div className={`col-12`}>
            <Spinner message={`Loading related content`} />
          </div>
        </div>
      )}

      <div className={`row ${relatedContentStyles.postList}`}>
        {!loadingPosts && (!posts || posts.length === 0) && (
          <p>No related content found</p>
        )}
        {posts &&
          BlogHelpers.relevant(posts, activeFilters).map(p => (
            <div
              key={p.id}
              className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 ${relatedContentStyles.postItemWrapper}`}
            >
              <div className={`${relatedContentStyles.postItemInnerWrapper} ${relatedContentStyles.postItem}`}>
                <div className={`${relatedContentStyles.postItemContent}`}>
                  <p className={`${relatedContentStyles.date}`}>
                    {moment(p.date).format("MMM D YYYY")}
                  </p>

                  {/*  <p className={`${relatedContentStyles.author}`}>
                  Published by Cubewise Team
                 {p.author && p.author.node && p.author.node.name}
                </p> */}
                  <div className={`${relatedContentStyles.tagList}`}>
                    {p.tags &&
                      p.tags.nodes &&
                      p.tags.nodes.map((tag, indx) => (
                        <span
                          className={`${relatedContentStyles.tag}`}
                          key={indx}
                        >
                          {tag.name}
                        </span>
                      ))}
                  </div>
                  <p
                    className={`${relatedContentStyles.title}`}
                    dangerouslySetInnerHTML={{
                      __html: p.title,
                    }}
                  />
                  {p.thumbnail && (
                    <div className={`${relatedContentStyles.featuredImage}`}>
                      <GatsbyImage image={p.thumbnail} alt={p.title} />
                    </div>
                  )}
                  {p.fimg_url && (
                    <div
                      className={`${relatedContentStyles.featuredImageRemote}`}
                    >
                      <img src={p.fimg_url} alt={p.title} />
                    </div>
                  )}
                  <p
                    className={`${relatedContentStyles.excerpt}`}
                    dangerouslySetInnerHTML={{
                      __html: p.excerpt,
                    }}
                  ></p>
                </div>
                <div className={`${relatedContentStyles.readmoreBtn}`}>
                  <Link
                    className={relatedContentStyles.postItem}
                    to={`/${blogUriRoot.current}${p.uri}`}
                  >
                    Read full article
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default RelatedContent
